var _defs, _rect, _rect2, _rect3, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#278e43;}.cls-2{fill:#ed2024;}.cls-3{fill:#fff;}.cls-4{fill:#febd11;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 1000,
    width: 2000,
    height: 1000
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 2000,
    height: 1000
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 667,
    width: 2000,
    height: 666
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    className: "cls-4",
    d: "M926.5,1016l73.6-516,73.6,516"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M925.05,993.62l222.42-471.38L1065.71,1037"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M930.26,971.82l351.48-384.88-229.86,467.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M941.66,952.51,1391,688.34,1033.44,1067.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M958.25,937.43l507.22-120-453.44,257"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M978.55,927.9l520.06,34.82-509.06,112"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1000.75,924.78l486.69,186.57L968,1068.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1022.89,928.35,1433,1250.08,949.29,1055.83"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1022.89,928.35,1433,1250.09,949.29,1055.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1043,938.28l297,428.31L935.09,1038.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1059.28,953.69l157.57,496.84-290.19-433"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1070.29,973.22l4.13,521.21L924.74,995.16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1075.06,995.13,925.39,1494.4l4.12-521.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1073.16,1017.47,783,1450.45,940.54,953.61"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1064.76,1038.26l-404.91,328.2,297-428.32"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1050.61,1055.65,566.94,1249.92,977,928.17"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1050.61,1055.65,566.94,1249.91,977,928.17"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1032,1068.1l-519.44,43.06L999.2,924.59"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1010.46,1074.49l-509-112,520.05-34.83"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M988,1074.26l-453.44-257,507.22,120"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M966.68,1067.44,609.14,688.19l449.32,264.16"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M948.29,1054.63,718.41,586.83l351.5,384.87"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M934.48,1037,852.71,522.19l222.43,471.37"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M926.5,1016l73.59-516,73.61,516"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKu);
export default __webpack_public_path__ + "static/media/ku.de20c7166981fef3512410b15fcf33fa.svg";
export { ForwardRef as ReactComponent };